import React from 'react';
import { motion } from 'framer-motion';
import { CoffeeCupIllustration } from './CoffeeCupIllustration';
import { NotifyForm } from './NotifyForm';
export function Hero() {
  return <main className="flex-grow flex flex-col items-center justify-center w-full max-w-5xl mx-auto px-6 py-12 relative z-10" data-id="element-39">
      <motion.div initial={{
      opacity: 0,
      scale: 0.9
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 1,
      ease: 'easeOut',
      delay: 0.2
    }} className="mb-8" data-id="element-40">
        <CoffeeCupIllustration data-id="element-41" />
      </motion.div>

      <div className="text-center max-w-3xl mx-auto mb-10" data-id="element-42">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut',
        delay: 0.4
      }} className="font-serif text-4xl md:text-5xl lg:text-6xl text-cream leading-tight mb-6" data-id="element-43">
          Your new favorite neighborhood{' '}
          <span className="text-red italic pr-2" data-id="element-44">café</span> is brewing.
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut',
        delay: 0.6
      }} className="font-sans text-base md:text-lg text-pale/90 leading-relaxed max-w-2xl mx-auto" data-id="element-45">
          A welcoming space to relax, catch up with friends, or dive into your
          work. Savor expertly brewed beverages, homemade treats, and our
          upcoming shake specials.
        </motion.p>
      </div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8,
      ease: 'easeOut',
      delay: 0.8
    }} className="flex flex-col items-center justify-center py-6 mb-2" data-id="element-46">
        <div className="flex items-center gap-5" data-id="element-47">
          <motion.div className="h-px w-12 md:w-16 bg-red" initial={{
          scaleX: 0
        }} animate={{
          scaleX: 1
        }} transition={{
          duration: 0.8,
          delay: 1
        }} data-id="element-48" />
          <span className="font-serif italic text-3xl md:text-5xl text-cream tracking-wide" data-id="element-49">
            Coming Soon
          </span>
          <motion.div className="h-px w-12 md:w-16 bg-red" initial={{
          scaleX: 0
        }} animate={{
          scaleX: 1
        }} transition={{
          duration: 0.8,
          delay: 1
        }} data-id="element-50" />
        </div>
        <p className="mt-4 font-script text-xl text-pale/70" data-id="element-51">
          your new favorite spot, just around the corner
        </p>
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8,
      ease: 'easeOut',
      delay: 1
    }} className="w-full" data-id="element-52">
        <NotifyForm data-id="element-53" />
      </motion.div>
    </main>;
}